module.exports = __webpack_public_path__ + "img/Group_7.5b42e008.png";